import React, {Component, Fragment} from "react";
import {TableCell} from "@material-ui/core";
import Chip from "@material-ui/core/Chip";
import config from "../../config.json";
import {getMessage} from "../../util";

class AnswerItem extends Component {

    getState = (state) => {
        switch (state) {
            case 'open':
                return (<Chip label={getMessage(this.props.meeting.meeting_type,'question_open',this.props.messages)}/>);
            case 'finished':
                return (<Chip label={getMessage(this.props.meeting.meeting_type,'question_finished',this.props.messages)}/>);
            default:
                return (<Chip label={getMessage(this.props.meeting.meeting_type,'question_ready',this.props.messages)}/>);

        }
    }


    render() {

        const voted = this.props.representative.answers[this.props.question.slug] ? true : false;

        const options = voted ? this.props.representative.answers[this.props.question.slug].options.reduce((acc, elem) => {
            acc[elem._id] = elem;
            return (acc);
        }, {}) : {};

        const total = voted ? Object.keys(options).reduce((acc, s) => {
            Object.keys(options[s].votes).forEach(k => {
                acc[k] = (acc[k] ? acc[k] : 0) + options[s].votes[k].shares;
            })
            return (acc);
        }, {}) : {};

        const number = {
            fontFamily: "Montserrat",
            fontSize: "1.3rem"
        };

        return (
            <Fragment>
                <TableCell>
                    {this.props.representative.identity}
                </TableCell>
                <TableCell>
                    {this.props.representative.data.name ? this.props.representative.data.name : 'unknown'}
                </TableCell>
                {this.props.representative.logged_before_quorum?(
                        this.props.common_shares.length > 0 ? (
                    voted ? (
                        <Fragment>
                            {this.props.question.options.sort((a, b) => {
                                return (a.order - b.order);
                            }).map(o => (
                                <TableCell key={o._id}>
                                    {options[o._id] && Object.keys(options[o._id].votes).map(s => (
                                        <Fragment key={s}>
                                            <span>{this.props.representative.shares[s].name}: </span>
                                            <span style={number}> {options[o._id].votes[s].shares.toLocaleString(navigator.language, {
                                    maximumFractionDigits: config.precision
                                })}</span>
                                            <br/>
                                        </Fragment>
                                    ))}
                                </TableCell>
                            ))}
                            <TableCell>
                                {this.props.common_shares.map(s => (
                                    <Fragment key={s}>
                                   <span>{this.props.representative.shares[s].name}: </span>
                                        <span style={number}> {(this.props.representative.shares[s].shares - total[s]).toLocaleString(navigator.language, {
                                    maximumFractionDigits: config.precision
                                        })}</span>
                                        <br/>
                                    </Fragment>
                                ))}
                            </TableCell>
                        </Fragment>
                    ) : (<Fragment>
                            <TableCell colSpan={this.props.question.options.length}>
                                No votó
                            </TableCell>
                            <TableCell>

                                {this.props.common_shares.map(s => (
                                    <Fragment key={s}>
                                <span>
                            <span>{this.props.representative.shares[s].name}: </span>
                                    <span style={number}> {this.props.representative.shares[s].shares.toLocaleString(navigator.language, {
                                    maximumFractionDigits: config.precision
                                    })}</span>
                                </span>
                                        <br/>
                                    </Fragment>
                                ))}
                            </TableCell>
                        </Fragment>
                    )
                ):(
                    <TableCell colSpan={this.props.question.options.length+1}>
                        {getMessage(this.props.meeting.meeting_type,'question_no_right',this.props.messages)}
                    </TableCell>
                )):(
                    <TableCell colSpan={this.props.question.options.length+1}>
                        {getMessage(this.props.meeting.meeting_type,'question_no_attendance',this.props.messages)}
                    </TableCell>
                )}

            </Fragment>
        );
    }
}


export default AnswerItem;